
import { mapGetters, mapActions } from "vuex"
import mixins from "vue-typed-mixins"
import { getFullName } from "@/utils/name"
import socialsMixin from "@/mixins/socials"
import menuMixin from "@/mixins/menu"

export default mixins(socialsMixin, menuMixin).extend({
  data: () => ({
    isMenuOpen: false,
  }),

  computed: {
    ...mapGetters("user", ["user"]),

    name (): string {
      return getFullName(this.user, this.$fmt.localize)
    },
  },

  mounted () {
    const isPanelActive = decodeURIComponent(document.cookie)
      .split(";")
      .some(c => c.trim() === "bvi_panelActive=true")

    if (isPanelActive)
      this.initBvi()
  },

  methods: {
    async initBvi () {
      if (window.bvi) return

      const { Bvi } = await import("bvi")

      window.bvi = new Bvi({
        target: ".bvi-open",
        fontSize: 16,
        theme: "black",
        speech: false,
        panelFixed: false,
      })
    },

    ...mapActions("user", { logout: "LOGOUT" }),
  },
})
